import React from 'react';
import { makeStyles } from '@mui/styles';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import { parseCoverUrl } from '../utils';

const useStyles = makeStyles((theme) => ({
  image: {
    borderRadius: theme.shape.borderRadius,
    height: '100%',
    maxHeight: '190px',
    width: '100%',
    objectFit: 'cover',
  },
}));

const VideoCard = ({ item }) => {
  const classes = useStyles();
  return (
    <>
      <Box
        component={Paper}
        borderRadius="10px"
        p={0.5}
        pb={{ xs: 1, md: 0.5 }}
        border={1}
        borderColor="grey.300"
      >
        <img
          className={classes.image}
          src={item.thumbnail_url || parseCoverUrl(item.video_url)}
        />
        <Box display="flex" alignItems="flex-start" p={1}>
          <Box flex={1}>
            <Typography>{item.headline}</Typography>
            <Typography
              variant="span"
              color="text.secondary"
              display="inline-block"
              width="180px"
              whiteSpace="nowrap"
              overflow="hidden"
              textOverflow="ellipsis"
            >
              {item.message}
            </Typography>
          </Box>
        </Box>
      </Box>
    </>
  );
};

export default VideoCard;
